<template>
    <list-container 
        :columns="columns" 
        :data="items" 
        :actions="actions" 
        titleKey="ClientName"
        :headerActitonStyle="headerActitonStyle"
        @loadMore="$emit('loadMore')">
         <template #col-id="{ row }">
            <div>
                <strong>{{ row.start_hour }} - {{ row.end_hour }} Hrs.</strong>
            </div>

        </template>
         <template #col-pallet_price="{ row }">
            <div>
                <strong>{{ formatCurrency(row.pallet_price,'USD') }}</strong>
            </div>
        </template>
         <template #col-box_price="{ row }">
            <div>
                <strong>{{ formatCurrency(row.box_price,'USD') }}</strong>
            </div>

        </template>
         <template #col-bulk_price="{ row }">
            <div>
                <strong>{{ formatCurrency(row.bulk_price,'USD') }}</strong>
            </div>
        </template>
        
    </list-container>
</template>

<script>

import ListContainer from '@/views/app/components/containers/ListContainer.vue';
import { formatCurrency } from '@/utils/helpers'
export default {
    name:'RangeTable',
    components: { ListContainer },
    props: {
        items: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            columns: [
                { key: 'id', label: 'range'},
                { key: 'pallet_price', label: 'pallet'},
                { key: 'box_price', label: 'box'},
                { key: 'bulk_price', label: 'bulk'},
            ],
            actions: [
                { tooltip: 'edit', icon: 'EditIcon', permissions:['IU RANGES EDIT'],customClass: 'custom-warning', onClick: row => this.$emit('edit',row) },
                { tooltip: 'delete', icon: 'TrashIcon',permissions:['IU RANGES DELETE'], customClass: 'custom-danger', onClick: row => this.$emit('delete',row) },
            ],
            headerActitonStyle:{ width:'10vw'}
        }
    },
    methods: {
        formatCurrency
    }
}
</script>

<style></style>